import { Resource } from "@q-food/q-food";

/**
 * The URL the *grid lookup* should load, given the options source the dropdown uses.
 *
 * A field's `optionsSource` points at `/api/reference/<resource>/search`, which projects only
 * id/name/number — deliberately, so the dropdown never triggers the per-row lazy-association fan-out
 * an index DTO mapper causes. The grid lookup is the advanced picker: it renders the resource's real
 * index columns, so loading that projection left every column but name and number blank and made
 * filtering or sorting on them pointless. Swap the base back to the resource's own index endpoint and
 * carry across the criteria the form field built — both endpoints parse it with the same RSQL against
 * the same entity and apply the same company/archived scope, so the row set is unchanged.
 *
 * Anything that is not a reference-search URL is returned untouched: fields already pointing at an
 * index endpoint (`/api/email-templates?criteria=…`), computed sub-resource ones
 * (`/api/relations/<id>/addresses`), and the bare `/api/reference/<resource>` single-value resolver.
 *
 * Deliberately its own module rather than a second export from `Autocomplete.ts`: that file imports
 * the user store, so importing this string helper from it pulled a translations fetch into anything
 * that touched it — including its own test.
 */
export function toIndexLookupUrl(optionsSource: string, resource: Resource): string {
	const [path, query] = optionsSource.split("?");

	if (!/^\/api\/reference\/[\w-]+\/search$/.test(path)) return optionsSource;

	return query ? `${resource.uri}?${query}` : resource.uri;
}
